import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ConsultationCTA from '../../components/ui/ConsultationCTA';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import ClientTestimonials from './components/ClientTestimonials';
import FeaturedCaseStudies from './components/FeaturedCaseStudies';
import ThoughtLeadership from './components/ThoughtLeadership';
import TrustSignals from './components/TrustSignals';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>RCEG AI Ventures - Leading AI Consultancy & Technology Solutions</title>
        <meta name="description" content="Transform your business with RCEG AI Ventures' cutting-edge artificial intelligence solutions, software development, cybersecurity, and analytics services. Trusted by 50+ enterprise clients worldwide." />
        <meta name="keywords" content="AI consultancy, artificial intelligence, software development, cybersecurity, analytics, machine learning, enterprise solutions" />
        <meta property="og:title" content="RCEG AI Ventures - Leading AI Consultancy & Technology Solutions" />
        <meta property="og:description" content="Transform your business with cutting-edge AI solutions, software development, and cybersecurity services from industry experts." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rcegai.com/homepage" />
        <link rel="canonical" href="https://rcegai.com/homepage" />
      </Helmet>

      <div className="min-h-screen bg-white">
        <Header />
        
        <main>
          {/* Hero Section */}
          <HeroSection />

          {/* Services Overview */}
          <ServicesOverview />

          {/* Client Testimonials */}
          <ClientTestimonials />

          {/* Featured Case Studies */}
          <FeaturedCaseStudies />

          {/* Thought Leadership */}
          <ThoughtLeadership />

          {/* Trust Signals */}
          <TrustSignals />
        </main>

        {/* Floating Consultation CTA */}
        <ConsultationCTA variant="floating" context="general" />

        {/* Footer */}
        <footer className="bg-foreground text-white py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              {/* Company Info */}
              <div className="lg:col-span-2">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
                    <span className="text-white font-bold text-sm">R</span>
                  </div>
                  <div>
                    <div className="text-xl font-bold">RCEG AI Ventures</div>
                    <div className="text-sm text-white/70">Leading AI Consultancy</div>
                  </div>
                </div>
                <p className="text-white/80 mb-6 max-w-md">
                  Transforming businesses through cutting-edge artificial intelligence solutions, software development, and cybersecurity services since 2020.
                </p>
                <div className="flex items-center space-x-4">
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                    <span className="text-white text-sm font-bold">Li</span>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                    <span className="text-white text-sm font-bold">Tw</span>
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
                    <span className="text-white text-sm font-bold">Gh</span>
                  </a>
                </div>
              </div>

              {/* Services */}
              <div>
                <h4 className="font-semibold text-lg mb-4">Services</h4>
                <ul className="space-y-2">
                  <li><a href="/services-overview" className="text-white/70 hover:text-white transition-colors">Software Development</a></li>
                  <li><a href="/services-overview" className="text-white/70 hover:text-white transition-colors">AI Models</a></li>
                  <li><a href="/services-overview" className="text-white/70 hover:text-white transition-colors">Analytics</a></li>
                  <li><a href="/services-overview" className="text-white/70 hover:text-white transition-colors">Cybersecurity</a></li>
                  <li><a href="/services-overview" className="text-white/70 hover:text-white transition-colors">AI Engineering</a></li>
                </ul>
              </div>

              {/* Company */}
              <div>
                <h4 className="font-semibold text-lg mb-4">Company</h4>
                <ul className="space-y-2">
                  <li><a href="/about-us" className="text-white/70 hover:text-white transition-colors">About Us</a></li>
                  <li><a href="/team-profiles" className="text-white/70 hover:text-white transition-colors">Our Team</a></li>
                  <li><a href="/contact-consultation-request" className="text-white/70 hover:text-white transition-colors">Contact</a></li>
                  <li><a href="#" className="text-white/70 hover:text-white transition-colors">Careers</a></li>
                  <li><a href="#" className="text-white/70 hover:text-white transition-colors">Privacy Policy</a></li>
                </ul>
              </div>
            </div>

            <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
              <div className="text-white/70 text-sm mb-4 md:mb-0">
                © {new Date().getFullYear()} RCEG AI Ventures. All rights reserved.
              </div>
              <div className="flex items-center space-x-6 text-sm text-white/70">
                <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
                <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Homepage;